import { AppThemeType, IThemeDefinition } from 'themes';
import { buildTheme } from 'themes/buildTheme';


const DefaultThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#1976d2",
        primaryLight: "#6bbafa",
        primaryDark: "#1565c0",
        secondaryMain: "#003587",
        secondaryLight: "#4a5eb8",
        secondaryDark: "#001159",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#0288d1",
        infoLight: "#03a9f4",
        infoDark: "#01579b",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#788898",
        mutedLight: "#a8b2bd",
        mutedDark: "#2c3e50",
        chipMain: "#d3dbe8",
        chipLight: "#f5f8ff",
        chipDark: "#a5abbb",
        highlightMain: "#42a5f5",
        highlightLight: "#6bbafa",
        highlightDark: "#0288d1",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f5f7fc",
        paperDark: "#edf0f8",
        white: "#fff",
        black: "#000",
        separator: "#dfe4f0",
        ai: "#d964E8",
        workAreaBackground: "#f5f7fc",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },
    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const AquaThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#39ACB3",
        primaryLight: "#C4D5D7",
        primaryDark: "#2C8A90",
        secondaryMain: "#2E8F96",
        secondaryLight: "#4FBEC5",
        secondaryDark: "#246E73",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#0288d1",
        infoLight: "#03a9f4",
        infoDark: "#01579b",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#7C9193",
        mutedLight: "#C4D5D7",
        mutedDark: "#617375",
        chipMain: "#B8E2E5",
        chipLight: "#EEF8F9",
        chipDark: "#88CDD2",
        highlightMain: "#62DDE4",
        highlightLight: "#8FEAF0",
        highlightDark: "#1EBFC8",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#F0FDFF",
        paperDark: "#E6F6F7",
        white: "#fff",
        black: "#000",
        separator: "#F2FCFD",
        ai: "#d964E8",
        workAreaBackground: "#f5f7fc",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },
    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const BlueThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#1976d2",
        primaryLight: "#6bbafa",
        primaryDark: "#1565c0",
        secondaryMain: "#003587",
        secondaryLight: "#4a5eb8",
        secondaryDark: "#001159",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#0288d1",
        infoLight: "#03a9f4",
        infoDark: "#01579b",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#788898",
        mutedLight: "#a8b2bd",
        mutedDark: "#2c3e50",
        chipMain: "#d3dbe8",
        chipLight: "#f5f8ff",
        chipDark: "#a5abbb",
        highlightMain: "#42a5f5",
        highlightLight: "#6bbafa",
        highlightDark: "#0288d1",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f5f7fc",
        paperDark: "#edf0f8",
        white: "#fff",
        black: "#000",
        separator: "#dfe4f0",
        ai: "#d964E8",
        workAreaBackground: "#fff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const PurpleThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#5B03A8 ",
        primaryLight: "#CAC4D3",
        primaryDark: "#5B03A8",
        secondaryMain: "#430087",
        secondaryLight: "#640494",
        secondaryDark: "#350169",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#5B03A8",
        infoLight: "#CAC4D3",
        infoDark: "#5B03A8",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#788898",
        mutedLight: "#CAC4D3",
        mutedDark: "#635870",
        chipMain: "#bcb7e0",
        chipLight: "#efeef7",
        chipDark: "#917fcd",
        highlightMain: "#B35CFF",
        highlightLight: "#ca8dfe",
        highlightDark: "#8b00f3",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f5f7fc",
        paperDark: "#FAF2FF",
        white: "#fff",
        black: "#000",
        separator: "#E6D5F0",
        ai: "#d964E8",
        workAreaBackground: "#fff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const RedThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#EE2323",
        primaryLight: "#F7B3B3",
        primaryDark: "#C21C1C",
        secondaryMain: "#7b0006",
        secondaryLight: "#F03A3A",
        secondaryDark: "#991515",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#e6008d ",
        errorLight: "#E6C4D2",
        errorDark: "#490124",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#a90d46",
        infoLight: "#d2194c",
        infoDark: "#860240",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#9A7777",
        mutedLight: "#F7B3B3",
        mutedDark: "#6F5656",
        chipMain: "#E0B7B7",
        chipLight: "#F7EEEE",
        chipDark: "#CD7F7F",
        highlightMain: "#FF5C5C",
        highlightLight: "#FF8D8D",
        highlightDark: "#F30000",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#FFFFFF",
        paperDark: "#FFF2F2",
        white: "#fff",
        black: "#000",
        separator: "#FFF2F2",
        ai: "#d964E8",
        workAreaBackground: "#fff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const GreenThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#027A34 ",
        primaryLight: "#43C474",
        primaryDark: "#024D20",
        secondaryMain: "#015C29",
        secondaryLight: "#03853B",
        secondaryDark: "#01421E",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#027A34",
        infoLight: "#43C474",
        infoDark: "#024D20",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#789885",
        mutedLight: "#97C2A8",
        mutedDark: "#5A7463",
        chipMain: "#B7E0C5",
        chipLight: "#EEF7F1",
        chipDark: "#7FCD9D",
        highlightMain: "#2CC76C",
        highlightLight: "#8DFEBA",
        highlightDark: "#00A64F",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f5f7fc",
        paperDark: "#F2FFF5",
        white: "#fff",
        black: "#000",
        separator: "#C5EBCE",
        ai: "#d964E8",
        workAreaBackground: "#ffff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const OrangeThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#D66A00",
        primaryLight: "#e28807",
        primaryDark: "#A65200",
        secondaryMain: "#B45400",
        secondaryLight: "#DB6B00",
        secondaryDark: "#8F4200",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#D66A00",
        infoLight: "#e28807",
        infoDark: "#A65200",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#987B60",
        mutedLight: "#D1A780",
        mutedDark: "#74614D",
        chipMain: "#E0B79B",
        chipLight: "#F7EFEA",
        chipDark: "#CD9A7F",
        highlightMain: "#F37400",
        highlightLight: "#fd9100",
        highlightDark: "#e44902",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f5f7fc",
        paperDark: "#FFF8F2",
        white: "#fff",
        black: "#000",
        separator: "#FFEBD9",
        ai: "#d964E8",
        workAreaBackground: "#fff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const WineThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#a90d46 ",
        primaryLight: "#d2194c",
        primaryDark: "#860240",
        secondaryMain: "#600303",
        secondaryLight: "#8a2e17",
        secondaryDark: "#4f0000",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#a90d46",
        infoLight: "#d2194c",
        infoDark: "#860240",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#987883",
        mutedLight: "#CFB0BB",
        mutedDark: "#6d4152",
        chipMain: "#e9d0db",
        chipLight: "#ecdce3",
        chipDark: "#917fcd",
        highlightMain: "#f54062",
        highlightLight: "#fb7090",
        highlightDark: "#E8B3CA",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f5f7fc",
        paperDark: "#fff2fb",
        white: "#fff",
        black: "#000",
        separator: "#F5D5E1",
        ai: "#d964E8",
        workAreaBackground: "#fff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

const GoldenThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#C89600",
        primaryLight: "#F2DC9B",
        primaryDark: "#A37800",
        secondaryMain: "#A87A00",
        secondaryLight: "#C89600",
        secondaryDark: "#866100",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#C89600",
        infoLight: "#F2DC9B",
        infoDark: "#A37800",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#9E875F",
        mutedLight: "#C4AE84",
        mutedDark: "#74684D",
        chipMain: "#E0C79B",
        chipLight: "#F7F1EA",
        chipDark: "#CDB07F",
        highlightMain: "#DBB700",
        highlightLight: "#e8d376",
        highlightDark: "#d89e00",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f5f7fc",
        paperDark: "#FFFBF2",
        white: "#fff",
        black: "#000",
        separator: "#F0E6CE",
        ai: "#d964E8",
        workAreaBackground: "#fff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};


const BlackThemeDef: IThemeDefinition = {
    color: {
        primaryMain: "#1C1C1C",
        primaryLight: "#D1D1D1",
        primaryDark: "#0E0E0E",
        secondaryMain: "#2A2A2A",
        secondaryLight: "#444444",
        secondaryDark: "#151515",
        warningMain: "#f79000",
        warningLight: "#faa32a",
        warningDark: "#f57d3d",
        errorMain: "#ff3d3d",
        errorLight: "#ef5350",
        errorDark: "#c62828",
        successMain: "#1cba6e",
        successLight: "#20D37D",
        successDark: "#145750",
        infoMain: "#0288d1",
        infoLight: "#03a9f4",
        infoDark: "#01579b",
        noticeMain: "#fff8e5",
        noticeLight: "#fffaeb",
        noticeDark: "#fff2cc",
        mutedMain: "#7D7D7D",
        mutedLight: "#D1D1D1",
        mutedDark: "#5E5E5E",
        chipMain: "#C4C4C4",
        chipLight: "#F2F2F2",
        chipDark: "#9A9A9A",
        highlightMain: "#42a5f5",
        highlightLight: "#6bbafa",
        highlightDark: "#0288d1",
        cancelMain: "#9e9e9e",
        cancelLight: "#c6c6c6",
        cancelDark: "#7a7a7a",
        paperMain: "#f8f8f8",
        paperDark: "#dddddd",
        white: "#fff",
        black: "#000",
        separator: "#F7F7F7",
        ai: "#d964E8",
        workAreaBackground: "#fff",
        workAreaBodyBackgound: "#a5abb8",
        workAreaBorder: "#e5e5e5"
    },

    font: {
        regular: "400",
        medium: "500",
        bold: "700",
        sizeXxs: "11px",
        sizeXs: "12px",
        sizeSm: "14px",
        sizeMd: "16px",
        sizeLg: "20px",
        sizeXl: "24px",
        sizeXxl: "32px",
    }
};

export const AppThemes: AppThemeType[] = [
    {
        key: "default",
        theme: buildTheme(DefaultThemeDef),
        color: DefaultThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Blue (light background)" },
            { locale: "es-ES", text: "Azul (fondo claro)" },
            { locale: "pt-BR", text: "Azul (fundo claro)" }
        ]
    },
    {
        key: "blue",
        theme: buildTheme(BlueThemeDef),
        color: BlueThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Blue" },
            { locale: "es-ES", text: "Azul" },
            { locale: "pt-BR", text: "Azul" }
        ]
    },
    {
        key: "aqua",
        theme: buildTheme(AquaThemeDef),
        color: AquaThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Aqua" },
            { locale: "es-ES", text: "Aqua" },
            { locale: "pt-BR", text: "Aqua" }
        ]
    },
    {
        key: "purple",
        theme: buildTheme(PurpleThemeDef),
        color: PurpleThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Purple" },
            { locale: "es-ES", text: "Púrpura" },
            { locale: "pt-BR", text: "Roxo" }
        ]
    },
    {
        key: "red",
        theme: buildTheme(RedThemeDef),
        color: RedThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Red" },
            { locale: "es-ES", text: "Rojo" },
            { locale: "pt-BR", text: "Vermelho" }
        ]
    },
    {
        key: "green",
        theme: buildTheme(GreenThemeDef),
        color: GreenThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Green" },
            { locale: "es-ES", text: "Verde" },
            { locale: "pt-BR", text: "Verde" }
        ]
    },
    {
        key: "orange",
        theme: buildTheme(OrangeThemeDef),
        color: OrangeThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Orange" },
            { locale: "es-ES", text: "Naranja" },
            { locale: "pt-BR", text: "Laranja" }
        ]
    },
    {
        key: "wine",
        theme: buildTheme(WineThemeDef),
        color: WineThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Wine" },
            { locale: "es-ES", text: "Vino" },
            { locale: "pt-BR", text: "Vinho" }
        ]
    },
    {
        key: "golden",
        theme: buildTheme(GoldenThemeDef),
        color: GoldenThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Golden" },
            { locale: "es-ES", text: "Dorado" },
            { locale: "pt-BR", text: "Dourado" }
        ]
    },
    {
        key: "black",
        theme: buildTheme(BlackThemeDef),
        color: BlackThemeDef.color.primaryMain,
        names: [
            { locale: "en-US", text: "Black" },
            { locale: "es-ES", text: "Negro" },
            { locale: "pt-BR", text: "Preto" }
        ]
    },
];
